import { PayloadAction } from "@reduxjs/toolkit";
import { NavigationState } from "../../types";

import { ClientEventHistoryPathFilter } from "../../types";

export const deleteClientEventHistoryFilter = (
  state: NavigationState,
  { payload }: PayloadAction<ClientEventHistoryPathFilter>
) => {
  state.clientEventsPathFilters = (state.clientEventsPathFilters || []).filter(
    (activeFilter) => activeFilter !== payload
  );
};
